/* Atelier Noir — JavaScript du thème (sans dépendance) */
(function () {
  'use strict';

  var T = window.theme || { routes: {}, strings: {} };
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var body = document.body;

  function debounce(fn, wait) {
    var t;
    return function () {
      var a = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, a); }, wait);
    };
  }

  function toast(msg) {
    var el = $('#Toast');
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
    requestAnimationFrame(function () { el.classList.add('is-visible'); });
    clearTimeout(toast._t);
    toast._t = setTimeout(function () {
      el.classList.remove('is-visible');
      setTimeout(function () { el.hidden = true; }, 300);
    }, 2600);
  }

  var overlay = $('#PageOverlay');
  function showOverlay(on, onClick) {
    if (!overlay) return;
    overlay.onclick = onClick || null;
    if (on) {
      overlay.hidden = false;
      requestAnimationFrame(function () { overlay.classList.add('is-visible'); });
    } else {
      overlay.classList.remove('is-visible');
      setTimeout(function () { if (!overlay.classList.contains('is-visible')) overlay.hidden = true; }, 300);
    }
  }

  /* ---------- Onglets des marques : l'onglet actif est amené en vue ---------- */
  var tabs = $('[data-tabs]');
  if (tabs) {
    var active = $('.is-active', tabs);
    if (active) {
      var left = active.offsetLeft - (tabs.clientWidth - active.offsetWidth) / 2;
      tabs.scrollLeft = Math.max(0, left);
    }
  }

  /* ---------- Menu mobile ---------- */
  var menuDrawer = $('#MenuDrawer');
  var menuBtn = $('[data-menu-toggle]');
  function openMenu() {
    if (!menuDrawer) return;
    menuDrawer.hidden = false;
    body.classList.add('is-locked');
    if (menuBtn) menuBtn.setAttribute('aria-expanded', 'true');
    requestAnimationFrame(function () { menuDrawer.classList.add('is-open'); });
    var c = $('[data-menu-close]', menuDrawer);
    if (c) setTimeout(function () { c.focus(); }, 60);
  }
  function closeMenu() {
    if (!menuDrawer || menuDrawer.hidden) return;
    menuDrawer.classList.remove('is-open');
    body.classList.remove('is-locked');
    if (menuBtn) { menuBtn.setAttribute('aria-expanded', 'false'); }
    setTimeout(function () { menuDrawer.hidden = true; }, 380);
  }
  if (menuBtn) menuBtn.addEventListener('click', openMenu);
  if (menuDrawer) {
    menuDrawer.addEventListener('click', function (e) {
      if (e.target === menuDrawer || e.target.closest('[data-menu-close]')) closeMenu();
    });
  }

  /* ---------- Recherche ---------- */
  var panel = $('#SearchPanel');
  var searchInput = $('[data-search-input]');
  var predictive = $('[data-predictive]');
  var searchBtn = $('[data-search-toggle]');
  function openSearch() {
    if (!panel) return;
    panel.hidden = false;
    if (searchBtn) searchBtn.setAttribute('aria-expanded', 'true');
    if (searchInput) setTimeout(function () { searchInput.focus(); }, 30);
  }
  function closeSearch() {
    if (!panel) return;
    panel.hidden = true;
    if (searchBtn) { searchBtn.setAttribute('aria-expanded', 'false'); searchBtn.focus(); }
  }
  if (searchBtn) searchBtn.addEventListener('click', function () { panel.hidden ? openSearch() : closeSearch(); });
  var searchClose = $('[data-search-close]');
  if (searchClose) searchClose.addEventListener('click', closeSearch);

  var predAbort;
  var runPredictive = debounce(function () {
    var q = searchInput.value.trim();
    if (!predictive) return;
    if (q.length < 2) { predictive.innerHTML = ''; return; }
    if (predAbort) predAbort.abort();
    predAbort = typeof AbortController !== 'undefined' ? new AbortController() : null;
    predictive.classList.add('is-loading');
    var url = T.routes.predictive_search_url + '?q=' + encodeURIComponent(q) +
      '&resources[type]=product,collection,query&resources[limit]=6&resources[options][fields]=title,product_type,variants.title,vendor,variants.sku,tag&resources[options][unavailable_products]=last&section_id=predictive-search';
    fetch(url, predAbort ? { signal: predAbort.signal } : undefined)
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var sec = $('#shopify-section-predictive-search', doc) || doc.body;
        predictive.innerHTML = sec.innerHTML;
        predictive.classList.remove('is-loading');
      })
      .catch(function (e) {
        if (e && e.name === 'AbortError') return;
        predictive.classList.remove('is-loading');
      });
  }, 220);
  if (searchInput) searchInput.addEventListener('input', runPredictive);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (panel && !panel.hidden) closeSearch();
    closeFilters();
    closeDrawer();
    closeMenu();
  });
  document.addEventListener('click', function (e) {
    if (panel && !panel.hidden && !e.target.closest('#Header')) closeSearch();
  });

  /* ---------- Panier (tiroir) ---------- */
  var drawer = $('#CartDrawer');
  function openDrawer() {
    if (!drawer) return;
    drawer.hidden = false;
    body.classList.add('is-locked');
    requestAnimationFrame(function () { drawer.classList.add('is-open'); });
    var c = $('[data-drawer-close]', drawer);
    if (c) setTimeout(function () { c.focus(); }, 60);
  }
  function closeDrawer() {
    if (!drawer || drawer.hidden) return;
    drawer.classList.remove('is-open');
    body.classList.remove('is-locked');
    setTimeout(function () { drawer.hidden = true; }, 380);
  }
  if (drawer) {
    drawer.addEventListener('click', function (e) {
      if (e.target === drawer || e.target.closest('[data-drawer-close]')) closeDrawer();
    });
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-cart-toggle]');
    if (!t || !drawer) return;
    if (document.body.classList.contains('template-cart')) return;
    e.preventDefault();
    openDrawer();
  });

  function setCartCount(n) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.classList.toggle('is-empty', !n);
    });
  }

  function refreshCartSections() {
    return fetch(T.routes.cart_url + '?sections=cart-drawer,header')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data['cart-drawer']) {
          var d = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
          var inner = $('#CartDrawerInner', d);
          var cur = $('#CartDrawerInner');
          if (inner && cur) cur.innerHTML = inner.innerHTML;
        }
      });
  }

  function changeLine(line, quantity, container) {
    var row = container ? container.closest('.line') : null;
    if (row) row.classList.add('is-updating');
    return fetch(T.routes.cart_change_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: parseInt(quantity, 10) })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart.status && cart.description) { toast(cart.description); if (row) row.classList.remove('is-updating'); return; }
        setCartCount(cart.item_count);
        if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
        return refreshCartSections();
      })
      .catch(function () { toast(T.strings.error); if (row) row.classList.remove('is-updating'); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-line-change]');
    if (!b) return;
    e.preventDefault();
    changeLine(b.getAttribute('data-line-change'), b.getAttribute('data-quantity'), b);
  });

  /* ---------- Filtres et tri (rendu AJAX, URL conservée) ---------- */
  var filters = $('[data-filters]');
  function openFilters() {
    if (!filters) return;
    filters.classList.add('is-open');
    body.classList.add('is-locked');
    showOverlay(true, closeFilters);
  }
  function closeFilters() {
    if (!filters || !filters.classList.contains('is-open')) return;
    filters.classList.remove('is-open');
    body.classList.remove('is-locked');
    showOverlay(false);
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-filters-open]')) { e.preventDefault(); openFilters(); }
    else if (e.target.closest('[data-filters-close]')) { e.preventDefault(); closeFilters(); }
  });

  var mqDesktop = window.matchMedia('(min-width: 990px)');
  var filterAbort;

  function renderFromHTML(html, pushUrl) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    ['[data-results]', '[data-facets-container]', '[data-results-count]'].forEach(function (sel) {
      var nu = $(sel, doc), cur = $(sel);
      if (nu && cur) cur.innerHTML = nu.innerHTML;
      else if (!nu && cur && sel === '[data-results]') cur.innerHTML = '';
    });
    var tb = $('.toolbar__filters span'), nb = $('.toolbar__filters span', doc);
    if (tb && nb) tb.textContent = nb.textContent;
    if (pushUrl) history.pushState({ ajax: true }, '', pushUrl);
    bindFacets();
  }

  function loadUrl(url, push) {
    var results = $('[data-results]');
    if (!results) { window.location.href = url; return; }
    if (filterAbort) filterAbort.abort();
    filterAbort = typeof AbortController !== 'undefined' ? new AbortController() : null;
    results.classList.add('is-loading');
    fetch(url, filterAbort ? { signal: filterAbort.signal } : undefined)
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        renderFromHTML(html, push ? url : null);
        var r2 = $('[data-results]'); if (r2) r2.classList.remove('is-loading');
        if (!mqDesktop.matches) closeFilters();
        var top = $('.toolbar');
        if (top) window.scrollTo({ top: top.getBoundingClientRect().top + window.pageYOffset - 140, behavior: 'smooth' });
      })
      .catch(function (e) {
        if (e && e.name === 'AbortError') return;
        window.location.href = url;
      });
  }

  function formUrl(form) {
    var params = new URLSearchParams();
    new FormData(form).forEach(function (v, k) { if (v !== '') params.append(k, v); });
    var sort = $('select[data-sort]');
    if (sort && sort.value) { params.delete('sort_by'); params.append('sort_by', sort.value); }
    var base = form.getAttribute('action') || window.location.pathname;
    var qs = params.toString();
    return base + (qs ? '?' + qs : '');
  }

  function bindFacets() {
    var form = $('[data-facets-form]');
    if (!form || form.__bound) return;
    form.__bound = true;
    form.addEventListener('submit', function (e) { e.preventDefault(); loadUrl(formUrl(form), true); });
    form.addEventListener('change', function () {
      if (mqDesktop.matches) loadUrl(formUrl(form), true);
    });
  }
  bindFacets();

  document.addEventListener('change', function (e) {
    var sel = e.target.closest('select[data-sort]');
    if (!sel) return;
    var form = $('[data-facets-form]');
    if (form) loadUrl(formUrl(form), true);
    else {
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', sel.value);
      window.location.href = u.toString();
    }
  });

  document.addEventListener('click', function (e) {
    var a = e.target.closest('.chip, .chips__clear, .facets__clear');
    if (!a || !a.getAttribute('href') || !$('[data-results]')) return;
    e.preventDefault();
    loadUrl(a.getAttribute('href'), true);
  });

  window.addEventListener('popstate', function () {
    if ($('[data-results]')) loadUrl(window.location.href, false);
  });

  /* ---------- Fiche produit ---------- */
  var productRoot = $('[data-product]');
  if (productRoot) {
    var variants = [];
    try { variants = JSON.parse($('[data-variants]', productRoot).textContent); } catch (e) {}
    var form = $('[data-product-form]', productRoot);
    var idInput = $('[data-variant-id]', productRoot);
    var addBtn = $('[data-add-to-cart]', productRoot);
    var addLabel = $('[data-add-label]', productRoot);
    var stockEl = $('[data-stock]', productRoot);
    var errEl = $('[data-form-error]', productRoot);
    var priceEl = $('[data-price]', productRoot);
    var lowThreshold = parseInt(productRoot.getAttribute('data-low-stock'), 10) || 5;

    var needsChoice = productRoot.getAttribute('data-needs-choice') === 'true';
    var hintEl = $('[data-size-hint]', productRoot);
    var buybar = $('[data-buybar]', productRoot);
    var buybarSize = $('[data-buybar-size]', productRoot);
    var buybarBtn = $('[data-buybar-btn]', productRoot);
    var sizesEl = $('.sizes', productRoot);
    var productTitle = productRoot.getAttribute('data-title') || '';
    var chosenSize = function () {
      var c = $$('.sizes__input:checked', productRoot);
      return c.length ? c.map(function (i) { return i.value; }).join(' / ') : '';
    };
    var findVariant = function () {
      var chosen = $$('.sizes__input:checked', productRoot).map(function (i) { return i.value; });
      if (!chosen.length) return needsChoice ? null : variants[0];
      return variants.filter(function (v) {
        return chosen.every(function (val, idx) { return v.options[idx] === val; });
      })[0];
    };

    var updateVariant = function () {
      var v = findVariant();
      $$('.sizes__input:checked', productRoot).forEach(function (i) {
        var out = $('[data-option-selected="' + i.getAttribute('data-option-index') + '"]', productRoot);
        if (out) out.textContent = i.value;
      });
      if (!v) {
        idInput.value = '';
        addBtn.disabled = false;
        if (needsChoice) {
          addBtn.setAttribute('aria-disabled', 'true');
          addLabel.textContent = T.strings.selectSize;
          if (buybarSize) buybarSize.textContent = T.strings.selectSize;
        } else {
          addBtn.disabled = true;
          addLabel.textContent = T.strings.soldOut;
        }
        return;
      }
      addBtn.removeAttribute('aria-disabled');
      if (hintEl) hintEl.hidden = true;
      if (buybarSize) buybarSize.textContent = chosenSize();
      idInput.value = v.id;
      addBtn.disabled = !v.available;
      addLabel.textContent = v.available ? T.strings.addToCart : T.strings.soldOut;
      if (stockEl) {
        stockEl.textContent = (v.available && v.managed && v.qty > 0 && v.qty <= lowThreshold)
          ? T.strings.lowStock.replace('__COUNT__', v.qty) : '';
      }
      if (priceEl) {
        var cur = $('.price__current', priceEl), cmp = $('.price__compare', priceEl);
        if (cur) cur.textContent = v.price;
        if (cmp) { if (v.on_sale) { cmp.textContent = v.compare; cmp.hidden = false; } else cmp.hidden = true; }
      }
      try {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        history.replaceState({}, '', u.toString());
      } catch (e) {}
      if (errEl) errEl.hidden = true;
    };
    $$('.sizes__input', productRoot).forEach(function (i) { i.addEventListener('change', updateVariant); });
    updateVariant();

    // barre d'achat mobile
    if (buybar && 'IntersectionObserver' in window && addBtn) {
      var io = new IntersectionObserver(function (entries) {
        var visible = entries[0].isIntersecting;
        var past = entries[0].boundingClientRect.top < 0;
        var show = !visible && past;
        buybar.classList.toggle('is-visible', show);
        document.body.classList.toggle('has-buybar', show);
      });
      io.observe(addBtn);
      buybarBtn.addEventListener('click', function () {
        if (addBtn.getAttribute('aria-disabled') === 'true') {
          if (hintEl) hintEl.hidden = false;
          if (sizesEl) sizesEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } else { form.requestSubmit ? form.requestSubmit() : addBtn.click(); }
      });
    }

    // quantité
    $$('[data-qty-step]', productRoot).forEach(function (b) {
      b.addEventListener('click', function () {
        var f = $('.qty__field', productRoot);
        var n = Math.max(1, (parseInt(f.value, 10) || 1) + parseInt(b.getAttribute('data-qty-step'), 10));
        f.value = n;
      });
    });

    // galerie
    var slides = $$('.gallery__slide', productRoot);
    var thumbs = $$('.gallery__thumb', productRoot);
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var idx = t.getAttribute('data-thumb');
        slides.forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-slide') === idx); });
        thumbs.forEach(function (x) { x.classList.toggle('is-active', x === t); });
      });
    });
    var stage = $('.gallery__stage', productRoot);
    if (stage && slides.length > 1) {
      var startX = null;
      var go = function (dir) {
        var cur = slides.findIndex(function (s) { return s.classList.contains('is-active'); });
        var nxt = (cur + dir + slides.length) % slides.length;
        if (thumbs[nxt]) thumbs[nxt].click();
      };
      stage.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) go(dx < 0 ? 1 : -1);
        startX = null;
      });
    }

    // ajout au panier
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (addBtn.getAttribute('aria-disabled') === 'true' || !idInput.value) {
          if (hintEl) hintEl.hidden = false;
          if (sizesEl) { sizesEl.scrollIntoView({ behavior: 'smooth', block: 'center' }); var f = $('.sizes__input', sizesEl); if (f) f.focus({ preventScroll: true }); }
          return;
        }
        if (addBtn.disabled) return;
        var addedSize = chosenSize();
        addBtn.disabled = true;
        var label = addLabel.textContent;
        addLabel.textContent = '…';
        var payload = new FormData(form);
        payload.append('sections', 'cart-drawer');
        payload.append('sections_url', window.location.pathname);
        fetch(T.routes.cart_add_url + '.js', {
          method: 'POST',
          headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: payload
        })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res.status) {
              if (errEl) { errEl.textContent = res.description || res.message || T.strings.error; errEl.hidden = false; }
              addLabel.textContent = label;
              addBtn.disabled = false;
              return;
            }
            if (res.sections && res.sections['cart-drawer']) {
              var d = new DOMParser().parseFromString(res.sections['cart-drawer'], 'text/html');
              var inner = $('#CartDrawerInner', d), cur = $('#CartDrawerInner');
              if (inner && cur) cur.innerHTML = inner.innerHTML;
            }
            return fetch(T.routes.cart_url + '.js').then(function (r) { return r.json(); }).then(function (cart) {
              setCartCount(cart.item_count);
              addLabel.textContent = T.strings.added;
              toast(addedSize ? T.strings.addedWithSize.replace('__TITLE__', productTitle).replace('__SIZE__', addedSize) : productTitle + ' — ' + T.strings.added);
              setTimeout(function () { addLabel.textContent = label; addBtn.disabled = false; updateVariant(); }, 1400);
              openDrawer();
            });
          })
          .catch(function () {
            if (errEl) { errEl.textContent = T.strings.error; errEl.hidden = false; }
            addLabel.textContent = label;
            addBtn.disabled = false;
          });
      });
    }
  }
})();

// Pied de page : accordéons sur mobile, listes ouvertes sur ordinateur
(function () {
  var mq = window.matchMedia('(min-width: 750px)');
  function sync() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-footer-acc]'), function (d) {
      if (mq.matches) { d.setAttribute('open', ''); } else if (!d.dataset.touched) { d.removeAttribute('open'); }
    });
  }
  Array.prototype.forEach.call(document.querySelectorAll('[data-footer-acc] summary'), function (s) {
    s.addEventListener('click', function (e) {
      if (mq.matches) { e.preventDefault(); return; }
      s.parentNode.dataset.touched = '1';
    });
  });
  sync();
  if (mq.addEventListener) { mq.addEventListener('change', sync); } else { mq.addListener(sync); }
})();
